import styled from 'styled-components';

export const UpgradeHoverBarWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-font-smoothing: antialiased;

    padding: 10px 15px;
    display: inline-flex;
    align-items: center;
    z-index: 50;

    background: #d9e7fd;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14),
        0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    .SVGInline {
        height: 30px;
    }
`;

export const ContentWrapper = styled.span`
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #3d4d75;
    margin-left: 15px;
    margin-right: 10px;
    white-space: nowrap;
`;

export const LinkWrapper = styled.span`
    font-weight: 700;
    color: #196fe0;
    &:hover {
        color: #2d49d1;
    }
`;
